export const GET_FILEDETAILS_ATTEMPT = 'GET_FILEDETAILS_ATTEMPT';
export const GET_FILEDETAILS_SUCCESS = 'GET_FILEDETAILS_SUCCESS';
export const GET_FILEDETAILS_FAILURE = 'GET_FILEDETAILS_FAILURE';
export const SORT_FILEDETAILS= 'SORT_FILEDETAILS';
